import React from "react";
import { STATUS_META } from "@/lib/api";

const TONES = {
  served: "bg-emerald-50 text-emerald-700 border-emerald-200",
  progress: "bg-sky-50 text-sky-700 border-sky-200",
  failed: "bg-red-50 text-red-700 border-red-200",
  pending: "bg-amber-50 text-amber-700 border-amber-200",
};

const DOTS = {
  served: "bg-emerald-500",
  progress: "bg-sky-500",
  failed: "bg-red-500",
  pending: "bg-amber-500",
};

export function StatusBadge({ status, pulse = false }) {
  const meta = STATUS_META[status] || { label: status, tone: "pending" };
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold ${TONES[meta.tone]}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${DOTS[meta.tone]} ${pulse ? "pulse-dot" : ""}`} />
      {meta.label}
    </span>
  );
}
